const rootPath = () => "/";
const aboutPath = () => "/about";
const networkPath = () => "/network";
const patientsPath = () => "/patients";
const professionalsPath = () => "/professionals";

export default {
  rootPath,
  aboutPath,
  networkPath,
  patientsPath,
  professionalsPath,
};
